export default "/_next/static/images/mazi-arjomand-07d39f310f0fd3b794264590da5475bd.png";